<template>
    <div class="tnc-wrapper">
        <h2><span style="font-size: 16pt">شرائط و ضوابط</span></h2>
        <h4>
            <strong><span style="font-size: 12pt">عمومی قواعد</span></strong>
        </h4>
        <ol>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ہماری ویب سائٹ مکمل طور پر قانونی عمر کے افراد تک محدود ہے جیسا کہ
                        دائرہ اختیار میں طے شدہ ہے جس میں فرد رہتا ہے۔</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ہماری ویب سائٹ کسی بھی قومی قوانین، وفاقی قوانین یا بین الاقوامی
                        قوانین کی کوئی ذمہ داری نہیں رکھتی جو ہماری ویب سائٹ استعمال کرنے والے کسی بھی صارف کی طرف سے
                        خلاف ورزی کی گئی ہو۔</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">صارفین اپنے اعمال کے خود ذمہ دار ہیں اور اپنے ہی ممالک کے قوانین کے
                        پابند ہیں، جس میں ریاستی قوانین یا قانونی مسائل شامل ہیں۔</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">تمام ایجنٹس اپنے متعلقہ اراکین کے کھاتوں کے ذمہ دار ہیں، اور ان کی
                        طرف سے جمع کرائے گئے تمام تصدیق شدہ شرطوں کا احترام کریں گے۔</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ایجنٹ ہماری ویب سائٹ کے پارٹنر نہیں ہیں۔ لہذا ہماری ویب سائٹ
                        کھلاڑیوں اور ایجنٹوں کے مابین کسی بھی تضاد یا تنازعات کی ذمہ داری نہیں رکھتی ہے۔</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">یہ صارف کی ذمہ داری ہے کہ وہ اپنے یوزر آئی ڈی اور پاس ورڈ کو غیر
                        مجاز استعمال سے بچائے۔ اگر صارف کا یوزر آئی ڈی اور پاس ورڈ چوری ہو جاتا ہے یا اس سے سمجھوتہ کیا
                        جاتا ہے، تو یہ صارف کی ذمہ داری ہے کہ وہ فوری طور پر اپنے ایجنٹ سے رابطہ کرے۔ اس کے بعد ایجنٹ
                        صارف کی یوزر آئی ڈی اور اس کے لیے پاس ورڈ تبدیل کر دے گا۔</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">یوزر آئی ڈی اور پاس ورڈ چوری ہونے کی صورت میں، صارف اپنے متعلقہ
                        اکاؤنٹس کے لیے ذمہ دار ہے اور جمع کرائے گئے تمام تصدیق شدہ شرطوں کا احترام کرے گا۔</span>
                </p>
            </li>
        </ol>
        <h4>
            <strong><span style="font-size: 12pt">گیمنگ کے قواعد</span></strong>
        </h4>
        <ol>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p><span style="font-size: 10.5pt">ہماری ویب سائٹ کے ذریعہ فیصلہ کردہ گیم کے نتائج حتمی اور پابند ہوں
                        گے۔</span></p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">تنازعہ کے تمام معاملات میں، ہماری ویب سائٹ کی انتظامیہ اور کھلاڑی
                        دونوں کو اس بات پر متفق ہونا چاہیے کہ ہماری ویب سائٹ کے لین دین لاگ ڈیٹا بیس تنازعہ میں حتمی
                        ثالث کے طور پر کام کرے گا۔ تمام تنازعات کو اس دن کے اندر اندر درج کیا جانا چاہیے جب میچ کا نتیجہ
                        طے ہو جائے۔ میچ کے دن کے بعد کسی دعوے کا احترام نہیں کیا جائے گا۔</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">پلیئر اپنے اکاؤنٹ کے تمام لین دین کی درستگی کی تصدیق کے لیے مکمل طور
                        پر ذمہ دار ہے۔</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">براہ کرم کمپیوٹر پر جمع کرانے سے پہلے کسی بھی غلطی، غلطی یا کوتاہی
                        کے لیے اپنی شرطوں کا جائزہ لینا یقینی بنائیں۔ کمپیوٹر پر شرط قبول کرنے کے بعد، اسے تبدیل یا
                        منسوخ نہیں کیا جا سکتا۔</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ہم ان شرائط و ضوابط کی خلاف ورزی، دھوکہ دہی کی سرگرمیوں میں ملوث
                        پائے جانے والے کسی بھی صارف کے اکاؤنٹ کو منجمد کرنے یا منسوخ کرنے کا حق محفوظ رکھتے ہیں، ان کی
                        خلاف ورزی کرنے، حملہ کرنے، جعل سازی کرنے، معیاری اصولوں کو خراب کرنے، یا سنڈیکیٹ بیٹنگ میں ملوث
                        پائے گئے، جس کے نتیجے میں اکاؤنٹ کے تمام بیلنس بغیر پیشگی اطلاع کے منجمد اور ضبط کیے جائیں
                        گے۔</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ہم کسی بھی ایسی شرط یا بیٹنگ ٹکٹ کو کالعدم یا منسوخ کرنے کا حق محفوظ
                        رکھتے ہیں جو سنڈیکیٹ بیٹنگ، منظم یا باہمی تعاون سے کی گئی بیٹنگ، ملی بھگت، دھوکہ دہی، سسٹم کے
                        غلط استعمال، تکنیکی خرابیوں یا غلط اوڈز سے فائدہ اٹھانے، یا غیر منصفانہ فائدہ حاصل کرنے کی کسی
                        بھی دوسری کوشش سے منسلک پائی جائے۔ اس سے متعلق جیتی گئی رقم واپس لی جا سکتی ہے، اور متعلقہ
                        اکاؤنٹ کو معطل یا بند کیا جا سکتا ہے۔
                    </span>
                </p>
            </li>
        </ol>
        <h4>
            <strong><span style="font-size: 12pt">حدود اور ذمہ داریاں</span></strong>
        </h4>
        <ol>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">مذکورہ بالا کی عمومیت کے تعصب کے بغیر، ہماری ویب سائٹ تخریب کاری،
                        زبردستی میجر، اور/یا ہماری ویب سائٹ کے مرکزی کمپیوٹر سسٹم یا ریکارڈ یا اس کے کسی بھی حصے کی
                        ناکامی یا نقصان یا تباہی کی صورت میں کسی بھی شخص کے لیے ذمہ دار نہیں ہوگی، یا تاخیر، نقصانات،
                        غلطیوں، کوتاہی یا کسی بھی دوسرے کے نتیجے میں کسی بھی ٹیلی کام کے نظام کی ناکامی یا کسی بھی ٹیلی
                        کام ڈیٹا کی ترسیل میں ناکامی کے نتیجے میں۔ کسی خاص نسل کے لیے داخلے کی عدم وصولی۔</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ہماری ویب سائٹ خدا کے کسی عمل کے نتیجے میں، دشمنی، فسادات، شہری
                        بدامنی، دہشت گردی کی کارروائی، حکومت یا اتھارٹی کے عمل (بشمول کسی لائسنس یا رضامندی سے انکار یا
                        منسوخی)، آگ کے دھماکے، سیلاب، چوری، بدنیتی پر مبنی نقصان، ہڑتال، لاک آؤٹ اور کسی بھی قسم کی
                        صنعتی کارروائی کے نتیجے میں کسی نقصان کی ذمہ دار نہیں ہوگی۔</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">نیٹ ورک کنکشن، کمیونیکیشنز، سسٹم یا انسانی غلطیوں کی صورت میں جو شرط
                        سے متعلق مسائل کا باعث بنتی ہیں جیسے کہ ڈبل بیٹس کو قبول کیا جانا، شرط کی تصدیق نہ ہو پانا، گیم
                        شروع ہونے کے بعد شرط لگانا وغیرہ۔ ہم ایسی غلطیوں کی صورت میں کیس کی بنیاد پر اس کا ازالہ کرنے کا
                        حق محفوظ رکھتے ہیں اور ایسی غلطیوں کو درست کرنے کے لیے کوئی اور کارروائی بھی کرتے ہیں۔ اس طرح کی
                        غلطیوں کے سلسلے میں ہم آپ یا کسی تیسرے فریق پر کوئی ذمہ داری عائد نہیں کریں گے۔ اگر آپ کو ایسی
                        غلطیوں کا سامنا ہوا ہے اور آپ اپنی اپ لائن پر اطلاع دئیے بغیر شرط لگانا جاری رکھیں گے، تو آپ کو
                        ذمہ دار ٹھہرایا جائے گا اور اگر غلطیاں دوبارہ ہوتی ہیں تو آپ کو جیت/ہار کے تمام نتائج کا احترام
                        کیا جائے گا۔</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">یہ قواعد و ضوابط فریقین کے درمیان مکمل معاہدے اور مفاہمت کو تشکیل
                        دیتے ہیں۔</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">اگر ان قواعد و ضوابط کے انگریزی زبان کے ورژن اور کسی دوسری زبان کے
                        ورژن کے درمیان کوئی تضاد ہے تو، انگریزی زبان کا ورژن دوسری زبانوں کی جگہ لے لیتا ہے اور اسے درست
                        اور درست سمجھا جاتا ہے۔</span>
                </p>
            </li>
        </ol>
        <BurgerMenu v-if="isMobile" />
    </div>
</template>
<script>
    import BurgerMenu from '@/components/burger-menu.vue';
    import { isMobile } from 'mobile-device-detect';
    export default {
        components: {
            BurgerMenu,
        },
        data: () => {
            return {
                isMobile,
            };
        },
    };
</script>
<style lang="scss" scoped>
    .tnc-wrapper {
        padding: 16px 24px;
        box-sizing: border-box;
        height: calc(100% - 56px);
        overflow-y: auto;
    }

    strong,
    h2,
    h4 {
        font-weight: 600;
    }
</style>
